<template>
	 

   <div class="data_brain_wrap">

	<div class="thirdLine" v-scroll-animate="'slide-itemgk'">
			 <!-- <span class="line line1"></span> -->
			 <div class="txt txt1">
			   <span>主要企业</span>
			 </div>
			 <!-- <span class="line line1"></span> -->
	   </div> 

    <el-row class="card_wrap" type="flex" v-scroll-animate="'fly-in-bottom'">
      <el-col
        class="brain_item"
        span="6"
        :xs="24"
        v-for="(item, index) in cardList"
        :key="index"
      >
	  <a v-if="!!item.websiteAddress" :href="item.websiteAddress" target="_blank">{{ item.companyName }}  </a> 
	  <a v-else-if="item.companyName == '河南中豫物流集团有限公司'" href="/businessDetail?title=%25E7%258E%25B0%25E4%25BB%25A3%25E7%2589%25A9%25E6%25B5%2581" target="_blank" >{{ item.companyName }}  </a> 
	  <a v-else-if="item.companyName == '河南港产运营管理有限公司'" href="/gangchan?index=00" target="_blank" >{{ item.companyName }}  </a> 
	  <a v-else-if="item.companyName == '河南港贸商业服务有限公司'" href="/detailPage2?index=00" target="_blank" >{{ item.companyName }}  </a> 
	  
	  

	  <a v-else>{{ item.companyName }}  </a> 
         
      </el-col>
    </el-row>
	 
  </div>
</template>
 <script>
   import API from '@/api/index'


 export default {
   data() {
	 return {
	   cardList: [],
	 }
   },
   mounted(){
	this.getHoldingCompanyFn()
   },
   methods:{
	   // 获取控股企业
	   async getHoldingCompanyFn() {
		
			try {
				let objParams={
					holdingCompanyType:0
				}
				const res = await API.getHoldingCompany(objParams)
				this.cardList=res.data.list
				console.log(res.data)
			} catch (error) {
			
			}
		},
   }
 }
 </script>
 
 <style lang="scss" scoped>
 .data_brain_wrap {
	background:#ffffff;
	padding-bottom: 100px;
	width: 100%;
   text-align: center;
   .brain_title {
	 color: #203040;
	 font-size: 40px;
	 font-weight: bold;
	 padding: 30px 0;
	 @media screen and (max-width: 768px) {
	   font-size: 1.5rem;
	 }
   }
   .brain_desc {
	 color: rgba(32, 48, 64, 0.75);
	 font-size: 22px;
	 letter-spacing: 4px;
	 @media screen and (max-width: 768px) {
	   font-size: 0.8rem;
	   line-height: 40PX;
	 }
   }
   .card_wrap {
	 width: 90%;
	 flex-wrap: wrap;
	 margin: 0px auto;
	//  gap:20px;
	//  justify-content: space-around;
	 @media screen and (max-width: 768px) {
	   width: 95%;
	 }
	 .brain_item {
	   transition: background-color 1s;
	  
	   font-size: 1rem;
	  
	  
	  
	   border-radius: 5px;
	   color: #015293;
	//    box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
	   margin-top: 40px;
	   position: relative;
	   a{
		display: block;
		width: 90%;
		// height: 4rem;
		// line-height: 4rem;
		padding: 20px;
		background: #e0f0fa;
		border: 1px solid #eeeeee;
		border-radius: 0.5rem;
		color: #015293;
		color: #333333;
		transition: font-size 0.5s ease;
	   }
	   a:hover{
		display: block;
		width: 90%;
		// height: 100%;
		// height: 4rem;

		padding: 20px;
	 
		background: #015293;
		border-radius: 1rem;
		 border: 1px solid #015293;
		color: #ffffff;
		// font-weight: bold;

		// font-size: 1.1rem !important;
            /* 鼠标悬停时字体变大 */
            perspective: 1000px;
	   }
	   @media screen and (max-width: 768px) {
		 font-size: 1rem;
		 display: flex;
		 flex-wrap: wrap;
		 justify-content: center;
		 margin-top: 20PX;
		 line-height: 3rem;
		 a:hover{
			padding-top:1.0rem;
			transform: translateX(0);
			padding-bottom:1.0rem;
		}
	   }
	    
	 }
   }
 }
 </style> 